import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ConnectionTestFailedAction = {
	type: 'CONNECTION_TEST_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ConnectionTestFailedAction => ({
	type: 'CONNECTION_TEST_FAILED',
	payload,
});
